import { compressToUTF16, decompressFromUTF16 } from 'lz-string'
import type { ShapeModel } from '../../../server/src/models'
import { mapValues } from '../utils'
import { DoodleChecklist, DoodleEllipse, DoodleImage, DoodleLine, DoodlePath, DoodleRect, DoodleShape, DoodleText } from './DoodleShape'

const compressPath = compressToUTF16
const decompressPath = decompressFromUTF16 as (path: string) => string

export const doodleShapeToModel = (shape: DoodleShape, page: number) =>
  ({
    type: shape.type,
    ...shape.properties,
    ...(shape.type === 'path' ? { dCompressed: 1, d: compressPath(shape.properties.d) } : {}),
    // チェック状態は送信しません。
    // （送っても受信側で無視します。チェック状態は check:changed コマンドでのみ変更します。現在のチェック状態を直近の check:changed だけで判別できるようにするためです。）
    ...(shape.type === 'checklist' ? { items: mapValues(shape.properties.items, item => ({ label: item.label, order: item.order })) } : {}),
    page,
    editable: undefined,
    userName: undefined,
    userColor: undefined,
  }) as ShapeModel & {
    editable: undefined
    userName: undefined
    userColor: undefined
  }

export const doodleShapeFromModel = (shape: ShapeModel, userName: string, userColor: string, editable: boolean) => {
  const layerId = shape.layerId ?? ''
  const color = shape.color ?? userColor
  // 色は図形側で持っている値を優先します。
  switch (shape.type) {
    case 'path':
      return new DoodlePath({
        ...shape,
        layerId,
        color,
        editable,
        d: shape.dCompressed ? decompressPath(shape.d) : shape.d,
        userName,
        userColor,
      })
    case 'line':
      return new DoodleLine({ ...shape, layerId, color, editable, userName, userColor })
    case 'rect':
      return new DoodleRect({ ...shape, layerId, color, editable, userName, userColor })
    case 'ellipse':
      return new DoodleEllipse({ ...shape, layerId, color, editable, userName, userColor })
    case 'text':
      return new DoodleText({ ...shape, layerId, color, editable, userName, userColor })
    case 'checklist':
      return new DoodleChecklist({ ...shape, layerId, color, editable, userName, userColor })
    case 'image':
      return new DoodleImage({ ...shape, layerId, color, editable, userName, userColor })
  }
}
